import { createContext, useContext } from "react";
import { APP_COLORS, appKey } from "./AppIcon";
import { APP_COVER_ART } from "./appCoverArt";

/*
  Figma "App cover · აპის ყდა": an app's artwork on its deep colour. It fills its parent, so
  the parent sets the size and clips it. `size` is card (340 × 112), hero, phone, or header
  and headerPhone for App header. Wider or taller than drawn, the art scales from its
  bottom-right corner, where every cover keeps its main shape.
*/
const AppCover = ({ app, size = "card", className = "" }) => {
  const key = appKey(app);
  const art = APP_COVER_ART[key]?.[size];
  if (!art) return null;
  const [width, height, shapes] = art;
  return (
    <svg
      aria-hidden="true"
      viewBox={`0 0 ${width} ${height}`}
      preserveAspectRatio="xMaxYMax slice"
      className={`absolute inset-0 h-full w-full ${APP_COLORS[key].deep} ${className}`}
      style={{ "--b": `var(--app-${key}-base)`, "--s": `var(--app-${key}-soft)`, "--d": `var(--app-${key}-deep)` }}
      dangerouslySetInnerHTML={{ __html: shapes }}
    />
  );
};

const AppScopeContext = createContext(null);

/** The app this screen belongs to, for popups, which render outside AppScope's element. */
export const useAppScope = () => useContext(AppScopeContext);

/**
 * Everything inside takes the app's colour wherever it would be mint: selected tabs, buttons,
 * links, hovers. @see styles/tokens.css. Without an `app` it changes nothing, and it stays the
 * same element either way, so moving between apps doesn't remount what's inside.
 */
export const AppScope = ({ app, className = "", children }) => {
  const key = app ? appKey(app) : null;
  return (
    <AppScopeContext.Provider value={key}>
      <div data-app={key || undefined} className={className}>
        {children}
      </div>
    </AppScopeContext.Provider>
  );
};

export default AppCover;
